import type { PipeTransform } from '@angular/core';
import { Pipe, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import type { OnyxOptional } from '@onyx/angular';
import { OnyxDatePipe, OnyxTimePipe } from '@onyx/angular';
import { OrderTimeWindowType } from '../../dashboard/orders/common/enums/order-time-window-type';
import type { OrderTimeWindow } from '../../dashboard/orders/common/interfaces/order-time-window';
import { DictionaryCode } from '../enums/dictionary-code';

@Pipe({
  name: 'timeWindows',
})
export class TimeWindowsPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);
  private readonly timePipe = inject(OnyxTimePipe);
  private readonly datePipe = inject(OnyxDatePipe);

  public transform(timeWindows?: OnyxOptional<OrderTimeWindow>): string | null {
    if (!timeWindows?.windows?.length) return null;

    const { type, windows } = timeWindows;
    const typeTranslation = this.translateService.instant(
      `${DictionaryCode.ORDER_TIME_WINDOW_TYPE}.${type}`,
    );

    switch (type) {
      case OrderTimeWindowType.FIX: {
        const { date, time } = windows[0] ?? {};
        if (!date || !time) return typeTranslation;

        return `${typeTranslation} · ${this.datePipe.transform(date, 'date-dot')} · ${this.timePipe.transform(time)}`;
      }

      case OrderTimeWindowType.OPENING_HOURS:
      case OrderTimeWindowType.INTERVAL: {
        const formattedWindows = windows
          .filter((window) => window?.date && window?.timeRange)
          .map(
            ({ date, timeRange }) =>
              `${this.datePipe.transform(date, 'date-dot')}, ${this.timePipe.transform(timeRange)}`,
          );
        if (!formattedWindows.length) return typeTranslation;

        return `${typeTranslation} · ${formattedWindows.join(' · ')}`;
      }

      default:
        return typeTranslation;
    }
  }
}
